import React from 'react';

/**
 * Verilock brand mark — a small green shield with a white V.
 * Used in nav and footer next to the wordmark.
 */
const ShieldLogo = ({ size = 24, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
  >
    <path
      d="M16 3 L27 7 V16 C27 22.5 22.3 27.6 16 29 C9.7 27.6 5 22.5 5 16 V7 Z"
      fill="#0a5c44"
    />
    <path
      d="M11 13 L16 22 L21 13"
      stroke="#ffffff"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default ShieldLogo;
